/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import { classNames as i } from "@progress/kendo-react-common";
import { UploadListGroup as l } from "./UploadListGroup.mjs";
class u extends e.Component {
  mapListGroups() {
    const { groupedFiles: s, navigationIndex: r, ...o } = this.props;
    return Object.keys(s).map((t, a) => {
      const p = s[t];
      return /* @__PURE__ */ e.createElement(l, { key: t, files: p, index: a, navigationIndex: r, ...o });
    });
  }
  render() {
    const s = i("k-upload-files");
    return /* @__PURE__ */ e.createElement("ul", { className: s, role: "list", id: this.props.listId }, this.mapListGroups());
  }
}
export {
  u as UploadList
};
